var _path, _path2, _path3, _rect, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _rect2, _g2, _rect3, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWatermelon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140 275C65.4 275 5 214.6 5 140C5 65.4 65.4 5 140 5C214.6 5 275 65.4 275 140C275 214.6 214.6 275 140 275Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.119 164.941L110.146 165.602L113.284 203.472L121.256 202.812L118.119 164.941Z",
    fill: "#1F201D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.7 165.2H154.7V203.2H162.7V165.2Z",
    fill: "#1F201D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_528",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 216,
    width: 90,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 216,
    width: 90,
    height: 15,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.2 228.2C162.672 228.2 181.7 225.961 181.7 223.2C181.7 220.439 162.672 218.2 139.2 218.2C115.728 218.2 96.7 220.439 96.7 223.2C96.7 225.961 115.728 228.2 139.2 228.2Z",
    fill: "#BFC3CE"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M213.9 157.3C213.9 157.3 218.5 153.9 219.3 152C220.3 149.6 221.3 147.2 221.3 144.5C221.3 142 220.7 139.7 219.6 137.7C219.4 137.3 219.1 136.9 218.8 136.6L216.2 133.4L159.7 64.4L157.3 61.4C153 56.1 146.6 52.6 139.8 52.2C139.4 52.2 138.9 52.2 138.4 52.2C137.6 52.2 136.8 52.2 136 52.3C131.4 52.7 127.1 54.4 123.6 57.1C120.7 59.3 117.2 62.9 115.2 65.9C115.1 66.1 115 66.2 114.8 66.4L57.7 135C57.5 135.2 57.4 135.4 57.2 135.6C55.6 138 54.7 140.8 54.7 143.8C54.7 146.9 55.6 149.7 57.2 152.1C57.4 152.5 57.7 152.8 58 153.1C59 154.1 60.1 155.2 61.2 156.1C79.8 172.9 107.4 183.5 138.1 183.5C168.3 183.6 195.3 173.5 213.9 157.3Z",
    fill: "#009D00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3 109.4C80.3 109.4 69.3 100.4 69.3 86.4C69.3 86.4 62.8 80.9 64.8 65.9",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8 75.9C76.8 75.9 71.8 85.9 69.3 86.4C59.7 88.3 54.8 68.9 54.8 68.9",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2 125.7L114.9 66.2C115 66 115.1 65.9 115.3 65.7C117.3 62.7 120.8 59.1 123.7 56.9C127.2 54.3 131.5 52.6 136.1 52.1C136.9 52 137.7 52 138.5 52C138.9 52 139.4 52 139.8 52C146.7 52.4 153 55.9 157.3 61.2L159.7 64.2L209.3 124.8C209.3 124.8 192.7 156.4 135.7 156.8C84.7 157.2 65.2 125.7 65.2 125.7Z",
    fill: "url(#paint0_linear_1_528)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M196.4 112.4C196.4 112.4 216.4 99.4 213.4 79.4C213.4 79.4 220.4 69.4 216.4 60.4",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M204.4 71.4C204.4 71.4 206.4 81.4 213.4 79.4C220.4 77.4 226.6 74.4 225 64.9",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110.7 78.9L97.7 94.1C95.9 96.2 96.1 99.3 98.2 101.1C100.3 102.9 103.4 102.7 105.2 100.6L118.3 85.4C120.1 83.3 119.9 80.2 117.8 78.4C115.7 76.6 112.5 76.8 110.7 78.9Z",
    fill: "#FFD7D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M123.1 64.3L118.4 69.7C116.6 71.8 116.9 74.9 118.9 76.7C121 78.5 124.1 78.2 125.9 76.2L130.6 70.8C132.4 68.7 132.1 65.6 130.1 63.8C128 62 124.9 62.2 123.1 64.3Z",
    fill: "#FFD7D9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M117.2 127.2C120.79 127.2 123.7 124.29 123.7 120.7C123.7 117.11 120.79 114.2 117.2 114.2C113.61 114.2 110.7 117.11 110.7 120.7C110.7 124.29 113.61 127.2 117.2 127.2Z",
    fill: "#4C1A1D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M159.2 127.2C162.79 127.2 165.7 124.29 165.7 120.7C165.7 117.11 162.79 114.2 159.2 114.2C155.61 114.2 152.7 117.11 152.7 120.7C152.7 124.29 155.61 127.2 159.2 127.2Z",
    fill: "#4C1A1D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M150.2 127.2C150.2 133.3 145.3 138.2 139.2 138.2C133.1 138.2 128.2 133.3 128.2 127.2",
    fill: "#4C1A1D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M167.7 145.2C170.461 145.2 172.7 142.961 172.7 140.2C172.7 137.439 170.461 135.2 167.7 135.2C164.939 135.2 162.7 137.439 162.7 140.2C162.7 142.961 164.939 145.2 167.7 145.2Z",
    fill: "#FF6874"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M108.7 145.2C111.461 145.2 113.7 142.961 113.7 140.2C113.7 137.439 111.461 135.2 108.7 135.2C105.939 135.2 103.7 137.439 103.7 140.2C103.7 142.961 105.939 145.2 108.7 145.2Z",
    fill: "#FF6874"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7 125.2C86.4614 125.2 88.7 122.961 88.7 120.2C88.7 117.439 86.4614 115.2 83.7 115.2C80.9386 115.2 78.7 117.439 78.7 120.2C78.7 122.961 80.9386 125.2 83.7 125.2Z",
    fill: "#F25C67"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M133.7 106.2C136.461 106.2 138.7 103.961 138.7 101.2C138.7 98.4386 136.461 96.2 133.7 96.2C130.939 96.2 128.7 98.4386 128.7 101.2C128.7 103.961 130.939 106.2 133.7 106.2Z",
    fill: "#F25C67"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M150.7 87.2C153.461 87.2 155.7 84.9614 155.7 82.2C155.7 79.4386 153.461 77.2 150.7 77.2C147.939 77.2 145.7 79.4386 145.7 82.2C145.7 84.9614 147.939 87.2 150.7 87.2Z",
    fill: "#F25C67"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M177.7 115.2C180.461 115.2 182.7 112.961 182.7 110.2C182.7 107.439 180.461 105.2 177.7 105.2C174.939 105.2 172.7 107.439 172.7 110.2C172.7 112.961 174.939 115.2 177.7 115.2Z",
    fill: "#F25C67"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M220.8 140.4C203.3 162.2 171.3 176.6 134.9 176.2C101.7 175.8 74.8 159.2 54.8 142.2C54.8 139.2 55.7 138 57.3 135.6C57.4 135.4 57.6 135.2 57.8 135L65.8 125.4C76.7 143.1 104.6 155.7 137.5 155.7C170.7 155.7 198.9 142.8 209.5 124.8L216.4 133.3L219 136.5C219.3 136.8 219.6 137.2 219.8 137.6C220.2 138.5 220.5 139.4 220.8 140.4Z",
    fill: "#DBEA9B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M221.5 144.2C221.5 147 220.5 149.4 219.5 151.7C219.2 152.3 218.6 153 217.9 153.8C217.2 151.9 216.1 149.6 214.7 147.1C213.9 145.5 212.9 143.9 212 142.1C211 140.3 208.3 136.4 204.6 131.3C194 116.7 175 92.1 161 75.1C150.2 62 140.7 55.4 134.5 52.1C135.1 52 135.7 51.9 136.3 51.9C137.1 51.8 137.9 51.8 138.7 51.8C139.2 51.8 139.6 51.8 140.1 51.8C145.2 52.1 150.1 54.1 154 57.4C154.7 57.9 155.3 58.5 155.9 59.1C156.1 59.3 156.4 59.6 156.6 59.8C156.7 59.9 156.7 59.9 156.8 60C156.9 60.1 156.9 60.1 157 60.2C157.2 60.5 157.5 60.7 157.7 61L160.1 64L209.7 124.5L216.6 133L219.2 136.2C219.5 136.6 219.8 136.9 220 137.3C220.1 137.5 220.2 137.8 220.3 138C220.4 138.2 220.5 138.5 220.6 138.7C220.7 138.9 220.8 139.1 220.8 139.4V139.5C220.9 139.7 220.9 139.9 221 140.1C221 140.1 221 140.1 221 140.2C221.3 141.4 221.5 142.8 221.5 144.2Z",
    fill: "url(#paint1_linear_1_528)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M109.2 221.2C118.865 221.2 126.7 216.275 126.7 210.2C126.7 204.125 118.865 199.2 109.2 199.2C99.535 199.2 91.7 204.125 91.7 210.2C91.7 216.275 99.535 221.2 109.2 221.2Z",
    fill: "#1F201D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M167.2 221.2C176.865 221.2 184.7 216.275 184.7 210.2C184.7 204.125 176.865 199.2 167.2 199.2C157.535 199.2 149.7 204.125 149.7 210.2C149.7 216.275 157.535 221.2 167.2 221.2Z",
    fill: "#1F201D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_528",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 203,
    width: 10,
    height: 10
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 203,
    width: 10,
    height: 10,
    fill: "url(#pattern1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.2 210.2C100.581 210.2 101.7 209.081 101.7 207.7C101.7 206.319 100.581 205.2 99.2 205.2C97.8193 205.2 96.7 206.319 96.7 207.7C96.7 209.081 97.8193 210.2 99.2 210.2Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_528",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 173,
    y: 203,
    width: 10,
    height: 10
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 173,
    y: 203,
    width: 10,
    height: 10,
    fill: "url(#pattern2)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.2 210.2C179.581 210.2 180.7 209.081 180.7 207.7C180.7 206.319 179.581 205.2 178.2 205.2C176.819 205.2 175.7 206.319 175.7 207.7C175.7 209.081 176.819 210.2 178.2 210.2Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_528",
    transform: "scale(0.0111111 0.0666667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1_528",
    transform: "scale(0.1)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1_528",
    transform: "scale(0.1)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_528",
    x1: 65.2484,
    y1: 104.427,
    x2: 209.368,
    y2: 104.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F50028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F50028"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_528",
    x1: 149.889,
    y1: 123.003,
    x2: 219.12,
    y2: 70.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#3A3A3A",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5256,
    stopColor: "#3A3A3A"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_528",
    width: 90,
    height: 15,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAGlAAACAwAAAtL/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAA8AWgMBIgACEQEDEQH/xACHAAACAwEAAAAAAAAAAAAAAAAABQMEBgIBAQAAAAAAAAAAAAAAAAAAAAAQAAAHAAMBAQAAAAAAAAAAAAABAgMEBQYgBxcWEhEAAQIDBgQDCQAAAAAAAAAAARECAAMEITHREpITQZGhBRCT01FhgbFismMUNRIBAAAAAAAAAAAAAAAAAAAAIP/aAAwDAQACEQMRAAAAxmqyOkHNxZIXzjsApktGVeJ0rNYf/9oACAECAAEFAOX/2gAIAQMAAQUA5f/aAAgBAQABBQCvqZVgqF1tIdSz1jESsuuKQecUY84ox5xRjzijEnrStWUnrFSW7TLzq0hCXYIcjXO6aba1G1Qj6zYhrXX34+vuQevuQ7rNaaz1eyMnr3eLOwfvnjH/2gAIAQICBj8AX//aAAgBAwIGPwBf/9oACAEBAQY/AAJGUBUJJjPUVIa03ZBb1WAZtS9zRe2wLyEWl+o4xe/UcYvfqOMXv1HGL36jjA2Jz5R9qqupYJp6ol/1gJ0SCXObMaL0sPhmodwv/GC7oAYa2XSVD2gWONPMK8hAa/s9RMcBa7ZmhfhkMfxKjyZvpwN3sVZn45ZD0XSI/g13kPwizsNd5D8IO12OpDOGaTNX7IQdlqB79mb6cOWhqGtPD9ebYOUE17Z7Qqo9jmD5Dw//2Q=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_1_528",
    width: 10,
    height: 10,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAFzAAABggAAAa7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAoACgMBIgACEQEDEQH/xABnAAEBAQAAAAAAAAAAAAAAAAAABQYBAQAAAAAAAAAAAAAAAAAAAAAQAQEBAQAAAAAAAAAAAAAAAAUAEAQRAQACAwEAAAAAAAAAAAAAAAEDBCAREkISAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQAAAIOdD//aAAgBAgABBQC//9oACAEDAAEFAL//2gAIAQEAAQUAELB7Cd//2gAIAQICBj8Af//aAAgBAwIGPwB//9oACAEBAQY/ALM1ydjuRCh1zo86MP/Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermelon);
export default __webpack_public_path__ + "static/media/watermelon.51447c0271f349ac17be5cacd00da41b.svg";
export { ForwardRef as ReactComponent };